'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CheckedOutIcon = require('./CheckedOutIcon');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CheckedOutIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/CheckedOutIcon/index.js
// module id = 1143
// module chunks = 1